import { cepMask } from "../../utils/masks";
import TextInput from "./TextInput";

function CepInput({...props}) {
    return (
        <TextInput mask={cepMask} {...props} />
    );
}

export default CepInput;